import React from 'react';
import ReactDOM from 'react-dom';
import { Route, BrowserRouter as Router } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import App from './App.js';
import About from './about.js';
import Contact from './contact.js';
import Services from './services';
import Photography from './photography.js';
import GalleryPage from './GalleryPage.js';        // ← new
import * as serviceWorker from './serviceWorker';
 
const routing = (
    <Router>
        <div>
            <Route exact path="/"              component={App} />
            <Route path="/about"               component={About} />
            <Route path="/contact"             component={Contact} />
            <Route path="/services"            component={Services} />
            <Route exact path="/photography"   component={Photography} />
            <Route path="/photography/:slug"   component={GalleryPage} />
        </div>
    </Router>
);
 
ReactDOM.render(routing, document.getElementById('root'));
 
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
 
